import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Textarea extends Component {
  static defaultProps = {
    maxChars: 500,
    required: true,
  };

  state = {
    currCharacters: 0,
  };

  render() {
    const { name, question, required, maxChars, onFieldChange } = this.props;
    const { currCharacters } = this.state;

    return (
      <div className="field">
        <label htmlFor={name} className="field__label">
          {question}
        </label>
        <textarea
          id={name}
          name={name}
          required={required}
          className="field__input"
          onInput={e => {
            this.setState({ currCharacters: e.target.value.length });
            onFieldChange(e.target, e.target.value, false);
          }}
          maxLength={maxChars}
        />
        <span className="field__helper">
          {currCharacters} de {maxChars}
        </span>
      </div>
    );
  }
}

Textarea.propTypes = {
  question: PropTypes.string.isRequired,
  maxChars: PropTypes.number,
  name: PropTypes.string.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default Textarea;
